var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { size: "large", closable: false },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("sui-icon", {
        staticStyle: { color: "black" },
        attrs: { name: "close" },
        on: { click: _vm.toggleModal },
      }),
      _c("sui-modal-header", { staticStyle: { "text-align": "center" } }, [
        _vm._v(" " + _vm._s(_vm.modalHeaderContent()) + " "),
      ]),
      _c(
        "sui-modal-content",
        { attrs: { scrolling: "" } },
        [
          _c("BaseUserForm", {
            ref: "userForm",
            attrs: {
              "modal-action": _vm.modalAction,
              "toggle-modal": _vm.toggleModal,
              getUsers: _vm.getUsers,
            },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.handleCancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { click: _vm.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }